module.exports = __webpack_public_path__ + "static/media/Get_your_paws_on_it-min.fc57b6b5.png";